const DictEntryDivergentDocError = require('./errors/DictEntryDivergentDocError');
const PersonTypeService = require('./PersonTypeService');

class PixDataValidationService {
  static validateDocument(dictDocument, document) {
    const dictDocumentCleared = PersonTypeService.getCpfCnpjNumber(dictDocument);
    const documentCleared = PersonTypeService.getCpfCnpjNumber(document);
    if (documentCleared && documentCleared !== dictDocumentCleared) {
      throw new DictEntryDivergentDocError();
    }
    return true;
  }
}

module.exports = PixDataValidationService;
